import type { ThemeOptions } from '@mui/material';
import highTideLogo from '../../assets/brandings/highTide/highTideLogo.png';
import highTideNavbarLogo from '../../assets/brandings/highTide/highTideNavbarLogo.png';

export const highTideTheme: ThemeOptions = {
  assets: {
    logoURL: highTideLogo,
    navbarLogoURL: highTideNavbarLogo,
  },
  palette: {
    primary: { main: '#172e4f' },
    secondary: { main: '#71b1e3' },
    background: {
      default: '#c1daee40',
      paper: '#fff',
    },
    rainfall: { main: '#2fae89' },
    text: { primary: '#444' },
    appBarBackground: {
      main: '#fff',
      light: '#fff',
      dark: '#fff',
      contrastText: '#fff',
    },
    appBarText: { main: '#172e4f' },
  },
};
